jQuery(window).scroll(function () {
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 80) {
    jQuery("header").addClass("scrolling");
  } else {
    jQuery("header").removeClass("scrolling");
  }
});
